import React, { useCallback, useEffect, useState } from "react";
import { Col, Form, Row, Tab, Tabs, Card } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";
import BulkInventory from "./BulkInvetory";
import BulkRoomRate from "./BulkRoomRate";
import BulkRestriction from "./BulkRestriction";
import DateRangePicker from "../../components/dateRange/DateRangePicker";
import { findByIdHotel } from "../HotelsManagement/HotelList/api";
import { useToastrContext } from "../../components/Provider/ToastrProvider";
import { tabLists } from "./utils";
import { FormControl, MenuItem, Select } from "@mui/material";
import { HotelDetails } from "../HotelFilter/Details";

const BulkRate = () => {
  const [activeKey, setActiveKey] = useState("inventory");
  const [hotelDetails, setHotelDetails] = useState({});
  const [contractType, setContractType] = useState("B2C");
  const [dateRange, setDateRange] = useState({
    startDate: dayjs(),
    endDate: dayjs().add(1, "day"),
  });

  const navigate = useNavigate();
  const { tab, hotelId } = useParams();
  const { errorResponseHandler } = useToastrContext();

  const handleDateRangeChange = (range) => {
    setDateRange({ ...range });
  };

  const fetchHotelDetails = useCallback(
    async (id) => {
      try {
        const result = await findByIdHotel(id);
        setHotelDetails(result?.data?.data || {});
      } catch (error) {
        errorResponseHandler(error);
      }
    },
    [errorResponseHandler]
  );

  const handleNavigate = (key) => {
    navigate(`/rate-management/bulk/${hotelId}/${key}`);
  };

  useEffect(() => {
    if (tab) {
      setActiveKey(tab);
    }
  }, [tab]);

  useEffect(() => {
    if (hotelId) fetchHotelDetails(hotelId);
  }, [hotelId]);

  const renderTabs = () => {
    const childprops = { hotelDetails, dateRange, contractType };
    return (
      <Tabs
        id="bulk-rate-tabs"
        activeKey={activeKey}
        onSelect={handleNavigate}
        className="mb-4"
      >
        <Tab eventKey="inventory" title="Bulk Update Inventory">
          <BulkInventory {...childprops} />
        </Tab>
        <Tab eventKey="rates" title="Bulk Update Rates">
          <BulkRoomRate {...childprops} />
        </Tab>
        <Tab eventKey="restrictions" title="Bulk Update Restrictions">
          <BulkRestriction {...childprops} />
        </Tab>
      </Tabs>
    );
  };

  return (
    <Card className="shadow-sm">
      <Card.Body>
        <HotelDetails hotelDetails={hotelDetails} isBorder />
        <Row className="align-items-end mt-3 mb-4">
          <Col md={4}>
            <Form.Label>Contract Type</Form.Label>
            <FormControl fullWidth>
              <Select
                labelId="contract-type-label"
                value={contractType}
                onChange={(e) => setContractType(e.target.value)}
              >
                {tabLists?.map((type) => (
                  <MenuItem key={type} value={type}>
                    {type}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Col>

          <Col md={8}>
            <Form.Group controlId="dateRange">
              <DateRangePicker
                {...dateRange}
                onChange={handleDateRangeChange}
              />
            </Form.Group>
          </Col>
        </Row>

        {renderTabs()}
      </Card.Body>
    </Card>
  );
};

export default BulkRate;
